const mainFilterToggles = document.querySelectorAll(".main-filter-toggle")

mainFilterToggles.forEach(toggle => {
  const title = toggle.querySelector(".main-filter-toggle__title")
  const titleContainer = toggle.querySelector(".main-filter-toggle__title > span")
  const body = toggle.querySelector(".main-filter-toggle__body")

  const openText = title?.getAttribute("data-open") ?? "Rozšířené hledání"
  const closeText = title?.getAttribute("data-close") ?? "Sbalit rozšířené"


  const toggleContent = () => { body?.classList.toggle("--active") }

  const toggleTitle = () => {
    if (titleContainer === null) return
    title?.classList.toggle("--active")
    body?.classList.contains("--active") ? titleContainer.textContent = closeText : titleContainer.textContent = openText
  }

  const handleToggle = (event: Event) => {
    event.preventDefault()

    toggleContent()
    toggleTitle()

  }

  title?.addEventListener("click", handleToggle)
})
